import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface Claim {
  id: string;
  claim_type: string;
  incident_date: string;
  description: string | null;
  status: string;
  created_at: string;
}

export const useClaims = (userId: string) => {
  const [claims, setClaims] = useState<Claim[]>([]);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    const fetchClaims = async () => {
      console.log("Fetching claims for user:", userId);
      try {
        const { data, error } = await supabase
          .from('claims')
          .select('*')
          .eq('user_id', userId)
          .order('created_at', { ascending: false });

        if (error) {
          console.error('Error fetching claims:', error);
          toast({
            variant: "destructive",
            title: "Error",
            description: "Failed to fetch claims. Please try again."
          });
          return;
        }

        console.log("Claims data:", data);
        setClaims(data || []);
      } catch (error) {
        console.error("Unexpected error:", error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "An unexpected error occurred."
        });
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchClaims();
    }
  }, [userId, toast]);

  return { claims, loading };
};